import { useView, PLATFORM, customElement, inject, bindable, TaskQueue } from 'aurelia-framework';
import { closest } from '@material/dom/ponyfill';

@customElement('connector-line')
@useView(PLATFORM.moduleName('./connector-line.html'))
export class ConnectorLine {
  constructor(@inject(Element) private element: HTMLElement, private taskQueue: TaskQueue) { }

  @bindable
  left: HTMLElement;
  leftChanged() {
    this.layout();
  }

  @bindable
  right: HTMLElement;
  rightChanged() {
    this.layout();
  }

  leftHigher: boolean;
  width: number;
  height: number;
  sizeObserver: ResizeObserver;
  rightSizeObserver: ResizeObserver;

  layout() {
    const details = closest(this.element, '.voucher-graph__voucher-details');
    if (!this.left?.offsetParent || !this.right?.offsetParent || !details) {
      return;
    }
    let el = this.left;
    let leftCoords = { top: 0, left: 0 };
    while (el !== details) {
      leftCoords.top += el.offsetTop;
      leftCoords.left += el.offsetLeft;
      el = el.offsetParent as HTMLElement;
    }

    el = this.right;
    let rightCoords = { top: 0, left: 0 };
    while (el !== details) {
      rightCoords.top += el.offsetTop;
      rightCoords.left += el.offsetLeft;
      el = el.offsetParent as HTMLElement;
    }

    leftCoords.top += this.left.clientHeight / 2;
    rightCoords.top += this.right.clientHeight / 2;

    this.leftHigher = leftCoords.top < rightCoords.top;
    this.element.style.top = `${this.leftHigher ? leftCoords.top : rightCoords.top}px`;
    this.height = Math.abs(rightCoords.top - leftCoords.top);
    this.element.style.height = `${this.height}px`;
    this.element.style.left = `${leftCoords.left + this.left.clientWidth}px`;
    this.width = rightCoords.left - leftCoords.left - this.left.clientWidth;
    this.element.style.width = `${this.width}px`;
    this.sizeObserver?.disconnect();
    this.sizeObserver = new ResizeObserver(() => this.layout());
    this.sizeObserver.observe(this.left);
    this.sizeObserver.observe(this.right);
  }

  attached() {
    this.layout();
  }

  detached() {
    this.sizeObserver?.disconnect();
    this.sizeObserver = undefined;
  }
}
